module.exports = __webpack_public_path__ + "static/media/wave.44ada2ed.png";